"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedqrcodesm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedqrcodesm` : '') + (description ? ` desc-brandedqrcodesm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedqrcodesm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedqrcodesm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#f26b1c",
    d: "M4 18.47v-2.49a.53.53 0 1 1 1.07 0v2.49a.46.46 0 0 0 .46.46h2.49a.53.53 0 0 1 0 1.07H5.53A1.53 1.53 0 0 1 4 18.47m14.93 0v-2.49a.53.53 0 0 1 1.07 0v2.49A1.53 1.53 0 0 1 18.47 20h-2.49a.53.53 0 0 1 0-1.07h2.49a.46.46 0 0 0 .46-.46m-9.42-4.52c.3 0 .54.24.54.54v1.99c0 .3-.24.53-.54.53H7.52a.53.53 0 0 1-.53-.53v-2c0-.29.24-.53.53-.53zm1.46 2.53v-1a.53.53 0 0 1 1.07 0v1a.53.53 0 0 1-1.07 0m5.5-3.52c.3 0 .54.24.54.53v2.99c0 .3-.24.53-.53.53h-2.99a.53.53 0 0 1-.53-.53v-2.99a.53.53 0 0 1 1.07 0v2.45h1.91v-1.91h-.46a.53.53 0 0 1 0-1.07zm-8.41 2.98h.92v-.92h-.92zm2.9-2.45v-.46H7.53a.53.53 0 1 1 0-1.07h3.98c.3 0 .54.24.54.54v1a.53.53 0 0 1-1.07 0m5.52-2.52a.53.53 0 1 1 0 1.07h-2a.53.53 0 0 1 0-1.07zm-5.51-3.45a.53.53 0 1 1 1.07 0v2.45h.46a.53.53 0 0 1 0 1.07h-1a.53.53 0 0 1-.53-.53zM9.5 7c.3 0 .54.24.54.53v2c0 .29-.24.53-.54.53H7.52A.53.53 0 0 1 7 9.5V7.52c0-.3.24-.53.53-.53zm6.97 0c.3 0 .53.24.53.53v2c0 .29-.24.53-.53.53h-2a.53.53 0 0 1-.53-.54v-2c0-.3.24-.53.54-.53zm-1.46 1.99h.92v-.92h-.92zm-6.96 0h.92v-.92h-.92zM4 8.02V5.53A1.53 1.53 0 0 1 5.53 4h2.49a.53.53 0 0 1 0 1.07H5.53a.46.46 0 0 0-.46.46v2.49a.53.53 0 0 1-1.07 0m14.93 0V5.53a.46.46 0 0 0-.46-.46h-2.49a.53.53 0 1 1 0-1.07h2.49A1.53 1.53 0 0 1 20 5.53v2.49a.53.53 0 0 1-1.07 0"
  }));
};
var _default = exports.default = brandedqrcodesm;